import {
    PiCakeLight,
    PiCheckCircle,
    PiGiftLight,
    PiTruck,
} from "react-icons/pi";

const Benefits: React.FC = () => {
    return (
        <>
            <div className="container">
                <div className={`benefit-block md:py-20 py-10`}>
                    <div className="list-benefit grid items-start lg:grid-cols-4 grid-cols-2 gap-[30px]">
                        <div className="benefit-item flex flex-col items-center justify-center">
                            <PiTruck size={52} />{" "}
                            <div className="heading6 text-center mt-5">
                                Nosotros si despachamos
                            </div>
                            <div className="caption1 text-secondary text-center mt-3">
                                Enviamos tus pedidos de manera segura y
                                protegidos en la RM.
                            </div>
                        </div>
                        <div className="benefit-item flex flex-col items-center justify-center">
                            <PiCakeLight size={52} />
                            <div className="heading6 text-center mt-5">
                                Innovación en sabores
                            </div>
                            <div className="caption1 text-secondary text-center mt-3">
                                Experimentar con sabores únicos y presentaciones
                                creativas.
                            </div>
                        </div>
                        <div className="benefit-item flex flex-col items-center justify-center">
                            <PiGiftLight size={52} />
                            <div className="heading6 text-center mt-5">
                                Acumula Puntos
                            </div>
                            <div className="caption1 text-secondary text-center mt-3">
                                Al comprar por nuestra web acumulas puntos para
                                futuros dctos.
                            </div>
                        </div>
                        <div className="benefit-item flex flex-col items-center justify-center">
                            <PiCheckCircle size={52} />
                            <div className="heading6 text-center mt-5">
                                Calidad y frescura
                            </div>
                            <div className="caption1 text-secondary text-center mt-3">
                                Utilizar ingredientes frescos y de alta calidad
                                en todos los productos.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Benefits;
